import React, { useState } from 'react';
import { LayoutChangeEvent, Text, View } from 'react-native';
import { Button } from '../crop-circle/Button';
import { SettingsIcon } from '../crop-circle/icons';
import { getMediaTitleForWidth } from '../media/mediaUtils';
import { tokens } from '../crop-circle/tokens';
import { TopComponentBarCropCircleProps } from './types';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

export const TopComponentBarCropCircle: React.FC<
  TopComponentBarCropCircleProps
> = ({ leftNode, onPresRight, title, rightNode, rightAccessibilityLabel }) => {
  const [titleWidth, setTitleWidth] = useState<number>(0);

  const onLayout = (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    // Subtract a buffer for padding/margins (account for right button/node)
    const constrainedWidth = Math.max(0, width - 60);
    if (constrainedWidth > 0 && constrainedWidth !== titleWidth) {
      setTitleWidth(constrainedWidth);
    }
  };

  const Title = title ? (
    <Text style={styles.titleText} numberOfLines={1}>
      {titleWidth > 0 ? getMediaTitleForWidth(title, '', titleWidth) : title}
    </Text>
  ) : (
    leftNode
  );

  const RightNode = rightNode
    ? rightNode
    : onPresRight && (
        <Button
          onPress={onPresRight}
          leftIcon={<SettingsIcon />}
          style={styles.filterButton}
          accessibilityLabel={rightAccessibilityLabel ?? 'Settings'}
        />
      );

  return (
    <View style={styles.containerHeader}>
      <View style={styles.headerAlign}>
        <View style={{ flex: 1 }} onLayout={onLayout}>
          {Title}
        </View>
        {RightNode}
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  containerHeader: {
    padding: tokens.spacing.lg,
  },
  headerAlign: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterButton: {
    width: 32,
    height: 32,
    minWidth: 32,
    maxHeight: 32,
    backgroundColor: 'transparent',
  },
  titleText: {
    ...tokens.typography.body.mediumEmphasised,
    color: role.textStrong,
  },
}));
